import axios from 'axios'
import _get from 'lodash/get'

export const DIVIDENDS_AND_INTEREST_GET = 'DIVIDENDS_AND_INTEREST_GET'
export const DIVIDENDS_AND_INTEREST_UPDATE = 'DIVIDENDS_AND_INTEREST_UPDATE'
export const DIVIDENDS_AND_INTEREST_SAVE = 'DIVIDENDS_AND_INTEREST_SAVE'
export const DIVIDENDS_AND_INTEREST_SAVING = 'DIVIDENDS_AND_INTEREST_SAVING'
export const DIVIDENDS_AND_INTEREST_SAVE_SUCCESS = 'DIVIDENDS_AND_INTEREST_SAVE_SUCCESS'
export const DIVIDENDS_AND_INTEREST_SAVE_ERROR = 'DIVIDENDS_AND_INTEREST_SAVE_ERROR'

export const getDividendsAndInterest = (selfAssessmentId) => (dispatch) => {
    axios
        .get(`/dividendsandinterest/${selfAssessmentId}`)
        .then((response) => {
            const dividendsAndInterest = { ...response.data, fetchSuccessful: true }

            dispatch(updateDividendsAndInterest(dividendsAndInterest))
        })
        .catch((error) => {
            if (_get(error, ['response', 'status']) === 404) {
                dispatch(updateDividendsAndInterest({ fetchSuccessful: true }))
            }
        })
}

export const updateDividendsAndInterest = (dividendsAndInterest) => ({
    type: DIVIDENDS_AND_INTEREST_UPDATE,
    dividendsAndInterest,
})

export const saveDividendsAndInterest = () => (dispatch, getState) => {
    const { assessment, dividendsAndInterest } = getState()

    dispatch(dividendsAndInterestSaving, dividendsAndInterest)

    axios
        .put(`/dividendsandinterest/${assessment.id}`, { ...dividendsAndInterest, selfAssessmentId: assessment.id })
        .then((response) => {
            dispatch(dividendsAndInterestSaveSuccess(response.data))
        })
        .catch((error) => {
            dispatch(dividendsAndInterestSaveError(dividendsAndInterest, _get(error, ['response', 'data'])))
        })
}

export const updateAndSaveDividendsAndInterest = (dividendsAndInterest) => (dispatch) => {
    dispatch(updateDividendsAndInterest(dividendsAndInterest))
    dispatch(saveDividendsAndInterest())
}

export const dividendsAndInterestSaving = (dividendsAndInterest) => ({
    type: DIVIDENDS_AND_INTEREST_SAVING,
    dividendsAndInterest,
})

export const dividendsAndInterestSaveSuccess = (dividendsAndInterest) => ({
    type: DIVIDENDS_AND_INTEREST_SAVE_SUCCESS,
    dividendsAndInterest,
})

export const dividendsAndInterestSaveError = (dividendsAndInterest, errorResponse) => ({
    type: DIVIDENDS_AND_INTEREST_SAVE_ERROR,
    dividendsAndInterest,
    errorResponse,
})
